document.addEventListener('DOMContentLoaded', function () {
  bindLuxBannerModalIframeFullscreenClass();

  document.querySelectorAll('.lux-banner:not([data-lux-banner-init])').forEach(function (banner) {
    banner.setAttribute('data-lux-banner-init', '');
    initLuxBannerModal(banner);
  });
});

/** Fullscreen do YouTube no modal: alguns mobile não aplicam :fullscreen ao iframe; classe espelha o estado. */
function bindLuxBannerModalIframeFullscreenClass() {
  if (document.documentElement.dataset.luxBannerModalFsSync) return;
  document.documentElement.dataset.luxBannerModalFsSync = '1';

  function sync() {
    var el = document.fullscreenElement || document.webkitFullscreenElement;
    document.querySelectorAll('.lux-banner__video-dialog-iframe').forEach(function (ifr) {
      ifr.classList.toggle('lux-banner__video-dialog-iframe--native-fs', ifr === el);
    });
  }

  document.addEventListener('fullscreenchange', sync);
  document.addEventListener('webkitfullscreenchange', sync);
}

function initLuxBannerModal(banner) {
  var dialog = banner.querySelector('.lux-banner__video-dialog');
  var openBtn = banner.querySelector('.js-lux-banner-video-open');
  var closeBtn = banner.querySelector('.js-lux-banner-video-close');
  var iframe = banner.querySelector('.js-lux-banner-video-iframe');
  if (!dialog || !openBtn || !iframe) return;

  var embedBase = iframe.getAttribute('data-embed-base');
  function clearVideo() {
    iframe.removeAttribute('src');
  }

  openBtn.addEventListener('click', function () {
    if (embedBase) {
      var sep = embedBase.indexOf('?') === -1 ? '?' : '&';
      iframe.setAttribute('src', embedBase + sep + 'autoplay=1');
    }
    dialog.showModal();
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      dialog.close();
    });
  }

  var surface = dialog.querySelector('.lux-banner__video-dialog-surface');
  dialog.addEventListener('click', function (e) {
    if (surface && !surface.contains(e.target)) {
      dialog.close();
    }
  });

  dialog.addEventListener('close', clearVideo);
}
